export default function Snackbar() {
  return {
    MuiSnackbarContent: {
      styleOverrides: {
        message: {
          whiteSpace: 'pre-line',
          wordBreak: 'break-word',
        },
      },
    },
  };
}
